import { useContext, useEffect, useState } from "react";
import ticketService from "../services/ticketService";
import { Link, useParams } from "react-router-dom";
import TicketCard from "./TicketCard";
import SpinnerOverlay from "./SpinnerOverlay";
import { CartContext } from "../context/CartContext";
import { useSearchParams } from "react-router-dom"



function TicketList() {
    const { slug } = useParams();
    const { cartItems } = useContext(CartContext);
    const [searchParams] = useSearchParams()
    const token = searchParams.get("token")
    const resellerCode = searchParams.get("code");
    const [tickets, setTicket] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    useEffect(() => {
        const fetchEventDetails = async () => {
            try {
                const ticketData = await ticketService.getTicketsForEvent(slug,token);
                setTicket(ticketData);
            } catch (err) {
                setError("Error al cargar los detalles del ticket.");
            } finally {
                setLoading(false);
            }
        };

        fetchEventDetails();
    }, [slug,token]);

    // Mostrar mensaje de carga mientras se obtiene el evento
    if (loading) {
        return <SpinnerOverlay isLoading={loading}/>
    }

    // Mostrar mensaje de error si ocurre un problema
    if (error) {
        return <div className="text-center text-red-500 text-xl my-40">No hay entradas disponibles</div>;
    }

    if (tickets.length === 0 ){
        return <div className="text-center text-red-500 text-xl mt-4">No hay entradas disponibles</div>;
    }
    return (
        <div className="flex flex-col m-auto max-w-7xl ">
            <div className="flex justify-between bg-zinc-900 p-4">
                <div>Tipo de ticket</div>
                <div>Precio</div>
                <div>Cantidad</div>
            </div>
            {tickets.map((ticket) => (
                <TicketCard key={ticket?.id} ticket={ticket}/>
            ))}
            <Link to={resellerCode ? `/carrito?code=${resellerCode}` : '/carrito'}className="sm:ml-auto">
            <button className="btn-primary p-2 sm:w-32 w-full my-4"
            disabled={cartItems.length  < 1}>
                Comprar
            </button>
            </Link>
        </div>
    );
}

export default TicketList;
